<template>
  <div class="relative -z-10 select-none">
    <img
      v-if="isMobile"
      src="@/assets/svg/404-bg-mobile.svg?url"
      alt="404"
      draggable="false"
      class="bg-image bg-image--mobile"
    />
    <img
      v-else
      src="@/assets/svg/404-bg.svg?url"
      alt="404"
      draggable="false"
      class="bg-image bg-image--desktop"
    />

    <div
      class="absolute inset-x-0 top-40 z-0 mt-65 text-center md:pt-65 xl:top-65 xl:pt-0"
    >
      <p class="text-subject uppercase text-primary">
        {{ $t('notFoundPage.lost') }}
      </p>
      <h3 class="text-[7.063rem] font-bold text-danger">404</h3>
      <h2 class="text-greeting font-bold text-primary-hover">
        {{ $t('notFoundPage.pageNotFound') }}
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { useDevicePlatform } from '../composables'

const { isMobile } = useDevicePlatform()

useHead({
  titleTemplate: (title) => `${title} - Not Found!`,
})
</script>

<style scoped lang="postcss">
.bg-image {
  @apply h-screen w-full;
}

.bg-image--desktop {
  @apply object-cover lg:aspect-video lg:h-auto lg:object-fill;
}

.bg-image--mobile {
  @apply object-fill lg:object-contain;
}
</style>
